import { CheckCircle } from "lucide-react";

export const ProjectTypeStep = ({ projectTypes, formData, onInputChange }) => (
  <div data-testid="quote-step-1" className="space-y-6">
    <div>
      <h2 className="font-heading text-2xl font-bold uppercase text-brand-navy mb-2">
        Select Project Type
      </h2>
      <p className="text-brand-slate">
        Choose the category that best describes your project
      </p>
    </div>

    <div className="grid gap-4">
      {projectTypes.map((type) => {
        const Icon = type.icon;
        const isSelected = formData.project_type === type.id;
        return (
          <button
            key={type.id}
            type="button"
            data-testid={`project-type-${type.id}`}
            onClick={() => onInputChange("project_type", type.id)}
            className={`flex items-center gap-4 p-6 rounded-sm border-2 transition-all duration-300 text-left ${
              isSelected
                ? "border-brand-orange bg-brand-orange/5"
                : "border-border hover:border-brand-orange/50"
            }`}
          >
            <div
              className={`w-14 h-14 rounded-sm flex items-center justify-center flex-shrink-0 ${
                isSelected
                  ? "bg-brand-orange text-white"
                  : "bg-brand-ice text-brand-navy"
              }`}
            >
              <Icon className="w-7 h-7" />
            </div>
            <div>
              <h3 className="font-heading text-xl font-bold uppercase text-brand-navy">
                {type.title}
              </h3>
              <p className="text-sm text-brand-slate">{type.description}</p>
            </div>
            {isSelected && (
              <CheckCircle className="w-6 h-6 text-brand-orange ml-auto" />
            )}
          </button>
        );
      })}
    </div>
  </div>
);
